/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";
import FBPixel from "./util/FBPixel";
import isApp from "shared/util/isApp";
import ClientStats from "shared/util/ClientStats";

import {
	SET_CURRENT_FIELD,
	SUBMIT_API,
	SUBMIT_API_FAIL,
	CONFIRM_RECAPTCHA_SUCCESS,
} from "ducks/signup";

import { FIELDS } from "apps/signup/util/constants";

export const trackOnboardingRegistered = (registrationType) => {
	const data = { "registration type": registrationType };
	Analytics.logUIEvent(Analytics.eventNames.onboardingRegistered, { data });
};


// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function signup(state, action) {
	switch (action.type) {
		case SET_CURRENT_FIELD: {
			if (
				state.currentField === FIELDS.DESKTOP_ENTRY &&
				action.field === FIELDS.EMAIL
			) {
				Analytics.logUIEvent(Analytics.eventNames.onboardingSelectJoinOnDesktop);
			}

			if (
				state.currentField === FIELDS.EMAIL &&
				action.field === FIELDS.REGISTRATION
			) {
				Analytics.logUIEvent(Analytics.eventNames.onboardingSelectedOnEmail);
			}

			return;
		}

		case SUBMIT_API: {
			Analytics.logUIEvent(Analytics.eventNames.onboardingSelectedCreateAccount);
			FBPixel.trackEvent("StartRegistration");
			return;
		}

		case SUBMIT_API_FAIL: {
			if (action.payload.field === FIELDS.EMAIL) {
				if (process.env.PLATFORM === "mobile") {
					if (isApp()) {
						ClientStats.update({
							skipDelay: true,
							statname: "app onboarding funnel - submit email failed",
						});
					} else {
						ClientStats.update({
							skipDelay: true,
							statname: "mobile web onboarding funnel - submit email failed",
						});
					}
				} else {
					ClientStats.update({
						skipDelay: true,
						statname: "desktop onboarding funnel - submit email failed",
					});
				}
			} else if (action.payload.field === FIELDS.REGISTRATION) {
				Analytics.logUIEvent(Analytics.eventNames.onboardingSelectedJoinOnRegistration2);

				if (process.env.PLATFORM === "mobile") {
					if (isApp()) {
						ClientStats.update("app onboarding funnel - username and password failed");
					} else {
						ClientStats.update("mobile web onboarding funnel - username and password failed");
					}
				} else {
					ClientStats.update("desktop onboarding funnel - username and password failed");
				}
			}

			return;
		}

		case CONFIRM_RECAPTCHA_SUCCESS: {
			const { payload: { score, isCaptchaShowing, page } } = action;
			Analytics.logUIEvent(
				Analytics.eventNames.recaptchaScore,
				{
					data: {
						score,
						isCaptchaShowing,
						page,
					},
				},
			);
			return;
		}

		/* eslint-enable max-len */

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/signup.js